// The elevation profile's y-axis. Chart.js fits the axis to the data, so a flat
// or nearly flat line — a canal towpath, or a live track that has barely
// started — zoomed into a sliver of a unit, drew as a cliff-free band across
// the whole chart and labelled its ticks "7.200000000000001 ft".

/** The smallest elevation span the axis shows, in the chart's own small unit. */
export function minElevationSpan(unit: string): number {
  return unit === 'ft' ? 100 : 30;
}

/**
 * The axis range for a profile flatter than [minSpan]: the line sits in the
 * middle of a [minSpan]-high axis, floored at 0 unless the route itself goes
 * below sea level. Null when the profile already spans enough, so Chart.js
 * fits it as before. Pure.
 */
export function elevationAxisRange(ys: number[], minSpan: number): { min: number; max: number } | null {
  let lo = Infinity;
  let hi = -Infinity;
  ys.forEach((y) => {
    if (!Number.isFinite(y)) return;
    if (y < lo) lo = y;
    if (y > hi) hi = y;
  });
  if (lo > hi || hi - lo >= minSpan) return null;

  const pad = (minSpan - (hi - lo)) / 2;
  let min = lo - pad;
  let max = hi + pad;
  if (min < 0 && lo >= 0) {
    max -= min;
    min = 0;
  }
  return { min, max };
}

/** A tick or readout value in whole units: "7 ft", never "7.200000000000001 ft". */
export function elevationLabel(value: number | string, unit: string): string {
  const n = Number(value);
  return `${Number.isFinite(n) ? Math.round(n) : value} ${unit}`;
}
